import { render, staticRenderFns } from "./video-red-packet.vue?vue&type=template&id=5c6408bd&scoped=true&lang=pug&"
import script from "./video-red-packet.vue?vue&type=script&lang=js&"
export * from "./video-red-packet.vue?vue&type=script&lang=js&"
import style0 from "./video-red-packet.vue?vue&type=style&index=0&id=5c6408bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6408bd",
  null
  
)

export default component.exports